import React, { useEffect } from 'react';
import useHandleErrorFields from '../../../../hooks/useHandleErrorFields';
import { PaymentStatus, PaymentStatusDataForm } from '../../../../app/models/PaymentStatus';

interface Props {
    paymentStatus: PaymentStatusDataForm
    setPaymentStatus: (load: PaymentStatusDataForm) => void;
    errorFields?: any;
}

const PaymentStatusForm = ({ paymentStatus, setPaymentStatus, errorFields }: Props) => {
    const { fieldErrorMessage, fieldHasError, onFocusRemove, setErrors } = useHandleErrorFields();

    useEffect(() => {
        setErrors(errorFields);
    }, [errorFields]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;

        setPaymentStatus({ ...paymentStatus, [name]: value });
    };

    return (
        <>
            <div className="mb-2 row">
                <h6 className="mb-4">
                    Los estados de pago se generarán siempre que todos los items de despacho se
                    encuentren en estado Finalizado
                </h6>

                <div className="w-50 mx-auto">
                    <label className="label mb-0">Fecha de emisión</label>
                    <input
                        type="date"
                        className={`form-control  ${fieldHasError('issue_date')}`}
                        name="issue_date"
                        id="issue_date"
                        value={paymentStatus.issue_date}
                        onChange={handleChange}
                        placeholder="Ingrese una fecha de emisión"
                        onFocus={() => onFocusRemove('issue_date')}
                    />
                    <div className="invalid-feedback" style={{ display: 'flex' }}>
                        {fieldErrorMessage('issue_date')}
                    </div>
                </div>
            </div>
        </>
    );
};

export default PaymentStatusForm;
